import proxy from "api/proxy";

async function handleAccept(storeId) {
  // Update taxes in charges selected for the given storeId
  const { [storeId]: currentTable } = useTable.getState();
  const selected = currentTable.selectedRows;
  if (tax.value && selected?.size > 0) {
    const charges_ids = Array.from(selected.keys());
    const args = {
      model: "hotel.folio.charge",
      ids: charges_ids,
      values: { taxes: [["add", [tax.value.id]]] },
    };

    const { error } = await proxy.save(args);
    // reset();
  }
}

function layout() {
  const ctxView = {
    model: "hotel.booking.wizard_update_taxes",
    // form_action: ["edit", "add"],
    // table_action: ["add"],
    fields: {
      accept: {
        type: "button",
        onSuccessMsg: "Impuestos agregados exitosamente!",
        color: "blue",
        // style: "w-full",
      },
    },
    list: [],
    form: [{ name: "accept" }],
    buttons: ["accept"],
  };

  return ctxView;
}

export { layout };
